export const TOP_MAIL_COUNTER_ID = 3788228;

type TopMailPageView = {
  id: number;
  type: "pageView";
  url: string;
};

type TopMailGoal = {
  id: number;
  type: "reachGoal";
  goal: string;
};

type TopMailQueue = {
  push(event: TopMailPageView | TopMailGoal): unknown;
};

declare global {
  interface Window {
    _tmr?: TopMailQueue;
  }
}

/** Queues a virtual SPA page view without exposing query parameters. */
export function trackTopMailPageView(pathname: string): void {
  const queue = window._tmr ?? (window._tmr = [] as unknown as TopMailQueue);
  queue.push({
    id: TOP_MAIL_COUNTER_ID,
    type: "pageView",
    url: pathname,
  });
}

/** Queues a VK Ads goal through the shared Top.Mail.Ru counter. */
export function trackTopMailGoal(goal: string): void {
  const queue = window._tmr ?? (window._tmr = [] as unknown as TopMailQueue);
  queue.push({
    id: TOP_MAIL_COUNTER_ID,
    type: "reachGoal",
    goal,
  });
}
